import { createTheme } from '@mui/material';
import themeOptions from './themeOptions';

const theme = createTheme(themeOptions);

export default theme;
